<template>
    <div class="app-body">
        <div class="a-flex-rsbc a-ptb-6">
            <span class="a-fs-16 a-fw-700">电费项目列表</span>
            <div class="a-flex-rcc">
                <!-- <el-button icon="el-icon-plus" type="primary" plain class="s-btn-add" @click="batchAddElectric">批量创建</el-button> -->
                <el-button icon="el-icon-plus" type="primary" class="s-btn-add" @click="editElectric">添加电费项目</el-button>
            </div>
        </div>
        <el-card class="el-main">
            <le-search-form @reset="handlerRest" @search="handlerSearch" id="leSearch">
                <le-select-remote-search label="电费项目" v-model="pageParam.params.id" :options="optionsElectric" placeholder="请选择电费项目(可搜索)" />
                <!-- <le-input label="电表号" v-model="pageParam.params.ammeterNumber" /> -->
                <le-select-remote-search label="电表号" v-model="pageParam.params.ammeterId" :options="optionsAmmeter" placeholder="请选择电表(可搜索)" />
                <le-select-remote-search label="物业" v-model="pageParam.params.propertyId" :options="optionsProperty" placeholder="请选择物业(可搜索)" />
                <le-select-local-search label="电费类型" v-model="pageParam.params.electricFeeType" :options="electricFeeTypeDic" />
                <le-select-local-search label="电费收取方式" v-model="pageParam.params.chargeFeeType" :options="chargeFeeTypeDic" />
                <le-select-remote-search label="关联项目" v-model="pageParam.params.incomeId" :options="optionsincomeDistri" placeholder="请选择（可输入搜索）" />
                <le-select-local-search label="状态" v-model="pageParam.params.status" :options="statusDic" />
            </le-search-form>
            <le-pagview ref="electricListPage" @setData="setTableData" :pageParam="pageParam" :isFixed="true" :tableRef="$refs.electricList" :pageSizeDefault='10'>
                <el-table 
                    ref="electricList" 
                    :data="tableData" 
                    :highlight-current-row="true" 
                    v-sticky="{ top: 0, parent:'.el-card__body' }" 
                    :span-method='mergeCols'
                    :border='true'
                    style="width: 100%">
                    <el-table-column prop="nameId" label="电费项目名称" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.name || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="chargeFeeTypeId" label="电费收取方式" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.chargeFeeType | initDic(chargeFeeTypeDic) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="chargePayeeTypeId" label="电费收款方" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.chargePayeeType | initDic(chargePayeeTypeDic) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="propertyListId" label="收款物业方" min-width="120">
                        <template slot-scope="{ row }">
                            <span v-if="row.propertyList.length == 1 && !row.propertyList[0]">-</span>
                            <div class="a-flex-rfsc a-flex-wrap" v-else>
                                <span class="stationTag" v-for="(item,index) in row.propertyList" :key="index">
                                    {{ item.propertyName?item.propertyName:'-' }}，占比{{ item.rate/100 }}%
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="electricFeeTypeId" label="电费类型" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.electricFeeType | initDic(electricFeeTypeDic) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="incomeListId" label="关联项目" min-width="120">
                        <template slot-scope="{ row }">
                            <span v-if="!row.incomeInfoList || !row.incomeInfoList.length">-</span>
                            <div class="a-flex-rfsc a-flex-wrap" v-else>
                                <span class="stationTag" v-for="(item,index) in row.incomeInfoList" :key="index">
                                    {{ item.name?item.name:'-' }}
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="unitPriceId" label="电费（/元/kwh）" min-width="120">
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat5(row.unitPrice) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stationNameId" label="站点" min-width="120">
                        <template slot-scope="{ row }">
                            <el-tag type="primary" size='mini' v-if="row.stationStatus== 1">已转移</el-tag>
                            <span>{{ row.stationName || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="meterNumberId" label="电表号" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.meterNumber || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="pid" label="状态" min-width="120">
                        <template slot-scope="{ row }">
                            <span :class="row.status == 1 ? 'a-c-green' : 'a-c-error'">{{ row.status | initDic(statusDic) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="pid" label="操作" width="110" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" @click="toElectricInfo(scope.row)">详情</el-button>
                            <el-dropdown placement="bottom-start" @command="handlerMoreOperation">
                                <el-button class="a-ml-10" type="text">更多操作</el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item :command='"1#"+scope.$index' :value="1">编辑</el-dropdown-item>
                                    <el-dropdown-item :command='"2#"+scope.$index' :value="2">删除</el-dropdown-item>
                                    <el-dropdown-item :command='"3#"+scope.$index' :value="3">移交</el-dropdown-item>
                                    <el-dropdown-item :command='"4#"+scope.$index' :value="4" v-if="scope.row.status == 0">启用</el-dropdown-item>
                                    <el-dropdown-item :command='"5#"+scope.$index' :value="5" v-if="scope.row.status == 1">停用</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>
            </le-pagview>
        </el-card>
        <electric-add-batch ref="batchAdd"></electric-add-batch>
        <electric-move ref="eleMove" @change='handleMoveSuccess'></electric-move>
    </div>
</template>

<script>
    import util from '../../../src/utils/util'
    import electricAddBatch from './child/electric-add-batch.vue'
    import electricMove from './child/electric-move.vue'
    export default {
        components: { electricAddBatch, electricMove },
        data () {
            return {
                util: util,
                tableData: [],
                pageParam: null,
                optionsElectric: {
                    url: this.$Config.apiUrl.electricFilter,
                    method: "post",
                    params: {},
                    showLoading: false,
                    labelKey: "name",
                    valueKey: "id",
                    searchKey: "name",
                    pageSize: 100
                },
                optionsProperty: {
                    url: this.$Config.apiUrl.propertyCompanyfilter,
                    method: "post",
                    params: {},
                    showLoading: false,
                    labelKey: "name",
                    valueKey: "id",
                    searchKey: "name",
                    pageSize: 100
                },
                optionsAmmeter: {
                    url: this.$Config.apiUrl.ammeterFilter,
                    method: "post",
                    params: {},
                    showLoading: false,
                    labelKey: "name",
                    valueKey: "id",
                    searchKey: "name",
                    pageSize: 100
                },
                optionsincomeDistri: {
                    url: this.$Config.apiUrl.incomeDistriList,
                    method: "post",
                    params: {},
                    showLoading: false,
                    labelKey: "name",
                    valueKey: "id",
                    searchKey: "name",
                },//项目数据
                chargeFeeTypeDic: [],
                chargePayeeTypeDic: [],
                electricFeeTypeDic: [],
                statusDic: [
                    {
                        value: 0,
                        label: '停用'
                    },
                    {
                        value: 1,
                        label: '启用'
                    }
                ]
            }
        },
        computed: {
            // 获取所有单元格合并数据
            spanArr() {
                if(!this.tableData.length) return []
                const mergeCols = ['nameId','chargeFeeTypeId','chargePayeeTypeId','propertyListId','electricFeeTypeId','incomeListId','unitPriceId','stationNameId','meterNumberId','pid','pid'] // 需要合并的列（字段）
                return util.getMergeCells(this.tableData, mergeCols, mergeCols)
            }
        },
        created () {
            this.$getDic('chargeFeeType','select').then(res=>{ this.chargeFeeTypeDic = res; })
            this.$getDic('chargePayeeType','select').then(res=>{ this.chargePayeeTypeDic = res; })
            this.$getDic('electricFeeType','select').then(res=>{ this.electricFeeTypeDic = res; })
            this.pageParam = {
                url: this.$Config.apiUrl.electricPage,
                method: "post",
                params: {
                    ammeterId: '',
                    propertyId: '',
                    id: '',
                    electricFeeType: '',
                    chargeFeeType: '',
                    incomeId: '',
                    status: ''
                },
                freshCtrl: 1,
            }
        },
        activated () {
            this.pageParam.freshCtrl++;
        },
        methods:{
            //获取列表
            setTableData(data) {
                let arr = []
                // 遍历处理后台返回数据
                data.map((item,index)=>{
                    if(item.stationAmmeterList.length) {
                        item.stationAmmeterList.map((ite,idx)=>{
                            let obj = {
                                ...ite,
                                chargeFeeType: item.chargeFeeType,
                                chargePayeeType: item.chargePayeeType,
                                electricFeeType: item.electricFeeType,
                                pid: item.id,
                                name: item.name,
                                companyName: item.companyName,
                                propertyList: item.propertyList,
                                incomeInfoList: item.incomeInfoList,
                                unitPrice: item.unitPrice || 0,
                                updateTime: item.updateTime,
                                status: item.status,
                                nameId: item.id,
                                propertyListId: item.id,
                                unitPriceId: item.id,
                                chargeFeeTypeId: item.id,
                                chargePayeeTypeId: item.id,
                                electricFeeTypeId: item.id,
                                incomeListId: item.id,
                                meterNumberId: ite.ammeterId + item.id,
                                stationNameId: ite.stationId + item.id,
                                stationStatus: ite.status
                            }
                            arr.push(obj)
                        })
                    }else {
                        let obj = {
                            chargeFeeType: item.chargeFeeType,
                            chargePayeeType: item.chargePayeeType,
                            electricFeeType: item.electricFeeType,
                            pid: item.id,
                            name: item.name,
                            companyName: item.companyName,
                            propertyList: item.propertyList,
                            incomeInfoList: item.incomeInfoList,
                            unitPrice: item.unitPrice || 0,
                            updateTime: item.updateTime,
                            status: item.status,
                            nameId: item.id,
                            propertyListId: item.id,
                            unitPriceId: item.id,
                            chargeFeeTypeId: item.id,
                            chargePayeeTypeId: item.id,
                            electricFeeTypeId: item.id,
                            incomeListId: item.id,
                            meterNumberId: item.id,
                            stationNameId: item.id,
                        }
                        arr.push(obj)
                    }
                })
                this.tableData = arr
            },
            handlerRest() {
                this.pageParam.params = {
                    ammeterId: '',
                    propertyId: '',
                    id: '',
                    electricFeeType: '',
                    chargeFeeType: '',
                    incomeId: '',
                    status: ''
                };
                this.handlerSearch()
            },
            handlerSearch() {
                this.$refs['electricListPage'].pageNum = 1
                this.pageParam.freshCtrl++;
            },
            editElectric (datas) {
                this.$router.push({
                    path: '/electric/electric-edit',
                    query:{
                        id: datas?datas.pid:'',
                    }
                })
            },
            batchAddElectric () {
                this.$refs['batchAdd'].dialogVisible = true
            },
            // 查看电费项目详情
            toElectricInfo (datas) {
                this.$router.push({
                    path: '/electric/electric-info',
                    query:{
                        id: datas?datas.pid:'',
                    }
                })
            },
            handlerMoreOperation (commands) {
                let command = commands.split('#')[0]
                let index = commands.split('#')[1]
                let datas = this.tableData[index]
                switch (command) {
                    case '1':
                        // 编辑电费项目
                        this.editElectric(datas)
                        break;
                    case '2':
                        // 删除电费项目
                        this.delElectricItem(datas)
                        break;
                    case '3':
                        // 移交电费项目
                        this.handOverEle(datas)
                        break;
                    case '4':
                        // 启用电费项目
                        this.handleSetStatus(datas, 1)
                        break;
                    case '5':
                        // 停用电费项目
                        this.handleSetStatus(datas, 0)
                        break;
                }
            },
            handleSetStatus (datas, status) {
                let content =  status == 1 ? '是否确认启用该电费项目？' : '是否确认停用该电费项目？'
                this.$confirm(content, '温馨提示')
                .then(_=>{
                    this.$Axios._post({
                        url: this.$Config.apiUrl.setElectricityStatus,
                        method: "post",
                        params: {
                            electricityId: datas.pid,
                            status: status
                        }
                    })
                    .then(res=>{
                        if (res.result.code == 0) {
                            this.$message.success('操作成功')
                            this.pageParam.freshCtrl++;
                        } else {
                            this.$message.error(res.result.message)
                        }
                    })
                    .catch(err=>{

                    })
                }).catch(_=>{})
            },
            // 删除电费项目
            delElectricItem (datas) {
                let content = datas.incomeList && datas.incomeList.length ? '该电费已关联了项目，是否确认删除？' : '是否确认删除？'
                this.$confirm(content,'温馨提示')
                .then(_=>{
                    this.$Axios._post({
                        url: this.$Config.apiUrl.electricDel,
                        method: "post",
                        params: {
                            id: datas.pid
                        }
                    })
                    .then(res=>{
                        if (res.result.code == 0) {
                            this.$message.success('操作成功')
                            this.pageParam.freshCtrl++;
                        } else {
                            this.$message.error(res.result.message)
                        }
                    })
                    .catch(err=>{

                    })
                })
                .catch(_=>{})
            },
            handOverEle (datas) {
                this.$refs['eleMove'].id = datas.pid
                this.$refs['eleMove'].optionsCompany.params.projectId = datas.pid
                this.$refs['eleMove'].originCompanyName = datas.companyName
                this.$refs['eleMove'].dialogVisible = true
            },
            handleMoveSuccess () {
                this.pageParam.freshCtrl++;
            },
            // 合并行
            mergeCols ({ row, column, rowIndex, columnIndex }) {
                return this.spanArr[rowIndex][columnIndex]
            },
            exportfile () {
                // this.$exfile({
                //     code: 15,
                //     fileName: this.pageParam.params.searchStartTime + ' 至 ' + this.pageParam.params.searchEndTime + ' 省份经营分析',
                //     startTime: this.pageParam.params.searchStartTime,
                //     endTime: this.pageParam.params.searchEndTime,
                //     params: this.pageParam.params
                // })
            }
        }
    }
</script>

<style lang="scss" scoped>
.s-btn-add{
    width: 135px;
}
/deep/ .s-search-label{
    width: 100px
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
    /*width: 0;宽度为0隐藏*/
    width: 0 !important;
    height: 0 !important;
}
/deep/ .el-table__fixed, /deep/ .el-table__fixed-right{
    height: 100% !important;
}
/deep/ .el-main .el-card__body::-webkit-scrollbar {
    /*width: 0;宽度为0隐藏*/
    width: 10px !important;
    height: 10px !important;
    display: block !important;
}
.stationTag{
    padding: 0px 6px;
    background: #f4f4f5;
    color: #909399;
    border: 1px solid #e9e9eb;
    border-radius: 3px;
    margin-right: 4px;
    margin-bottom: 4px;
    font-size: 12px;
    word-break: keep-all;
}
</style>